import Vue from "vue";
import Router from "vue-router";
import tokenHelper from "./helpers/tokenHelper";

const Dashboard = () => import('./views/Dashboard.vue')
const Stat = () => import('./views/Stat.vue')
const Login = () => import('./views/Login.vue')
const Admin = () => import('./views/Admin.vue')
const Tools = () => import('./views/Tools.vue')
/* const Test = () => import('./views/Test.vue')
const Rails = () => import('./views/Rails.vue') */
const EventDetails = () => import('./views/EventDetails.vue')

/* function lazyLoad(view) {
  return () => import(`@/views/${view}.vue`);
} */

function isLoggedIn() {
  return localStorage.getItem("token") && localStorage.getItem("refresh_token");
}

function isAdmin() {
  const token = localStorage.getItem("token");
  return (token && tokenHelper.isAdmin(token));
}

// Props a partire dai params injectati
function dynamicPropsFn(route) {
  return {
    selectedStructureID: route.params.selectedStructureID,
    selectedSensorID: route.params.selectedSensorID,

  }
}

/* function getSelectedProps(from, to){

} */

Vue.use(Router);
const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/dashboard",
      name: "home",
      component: Dashboard,
      props: dynamicPropsFn,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/",
      redirect: "/dashboard"
    },
    {
      path: "/stats",
      name: "stat",
      component: Stat,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/tools",
      name: "tools",
      component: Tools,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/admin",
      name: "admin",
      component: Admin,
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    },
    {
      path: "/details",
      name: "details",
      component: EventDetails,
      props: dynamicPropsFn,
      meta: {
        requiresAuth: true
      }
    }/* ,
    {
      path: "/test",
      name: "test",
      component: Test,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/rails",
      name: "rails",
      component: Rails,
      meta: {
        requiresAuth: true
      }
    } */
  ]
});

router.beforeEach((to, from, next) => {
  if ((!isLoggedIn() || (!isAdmin())) && to.matched.some(record => record.meta.requiresAdmin)) {
    next({
      name: "home"
    });
  } else
    if (isAdmin() && to.name !== "admin") {
      next({
        name: "admin"
      });
    }
    else if (!isLoggedIn() && to.matched.some(record => record.meta.requiresAuth)) {
      next({
        name: "login"
      });
    } else if (to.name === "login" && isLoggedIn()) { // Redirect user to homepage
      return next({ path: "/" });
    } else {
      // In base alla route -> inject di struttura e sensore selezionato
      to.params.selectedStructureID = from.name,
        to.params.selectedSensorID = from.name
      next(to.params);
    }
});

export default router;
